var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSber = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m11.96 2.932 1.56-1.15A8 8 0 0 0 8.493 0v.016A7.98 7.98 0 0 0 3.14 2.088l-.006-.007A7.95 7.95 0 0 0 .5 8.008a7.98 7.98 0 0 0 2.072 5.353l-.007.006A7.95 7.95 0 0 0 8.465 16h.027a7.98 7.98 0 0 0 5.362-2.08l.013.015A7.99 7.99 0 0 0 16.5 8.008c0-.489-.047-.962-.126-1.435L14.656 7.85v.158a6.1 6.1 0 0 1-1.815 4.349l-.014-.014a6 6 0 0 1-4.494 1.81 2 2 0 0 1-.156-.013v.008a6.1 6.1 0 0 1-4.026-1.799l.006-.006a6.06 6.06 0 0 1-1.81-4.497q.001-.074.013-.153h-.008a6.14 6.14 0 0 1 1.799-4.026l.006.006A6.09 6.09 0 0 1 8.492 1.86c.11 0 .205 0 .315.016l.001-.02a6.17 6.17 0 0 1 3.152 1.076"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.829 3.121c.378.489.694 1.025.962 1.592L8.508 10.09 5.45 8.166V5.864l3.042 1.907z"
})));
export default SvgSber;